import React, { Component } from "react";
import { connect } from "react-redux";
import { change } from "redux-form";
import ReduxForm from "../components/Form";
import {
  toRenderSelectFormat,
  toRenderSelectBannerplaces,
  toRenderSelectFormats,
  toRenderFormats,
  getDates
} from "redux/selectors";
import { refresh as load } from "redux/stat/actions";
import { changeLocation } from "redux/router/actions";
import { identity, difference, intersection, isEmpty, path } from "ramda";
import { getFormats } from "redux/helpers";

class Form extends Component {
  componentWillReceiveProps(nextProps) {
    const {
      match: { params: { publisherID: nextPublisherId } },
      start,
      stop,
      optionsAvailableFormats: nextOptionsFormats,
      formats: nextFormats
    } = nextProps;
    const {
      match: { params: { publisherID } },
      initialValues,
      change
    } = this.props;

    const formats = getFormats(nextFormats || "");

    const newFormats = intersection(nextOptionsFormats, formats);

    if (!isEmpty(difference(formats, newFormats))) {
      change("statForm", "formats", newFormats.join(","));
    }

    if (nextPublisherId !== publisherID) {
      this.onSubmit({
        ...initialValues,
        site_id: nextPublisherId,
        start,
        stop
      });
    }
  }

  onChangeBannerPlace = identity;

  onSubmit = data => {
    const { load, start, stop } = this.props;
    const { site_id, bannerPlaces, formats, ...rest } = data;

    load({
      name: "bySite",
      site_id,
      start,
      stop,
      bannerPlaces,
      formats,
      ...rest
    });
  };

  render() {
    return (
      <ReduxForm
        {...this.props}
        onChangeBannerPlace={this.onChangeBannerPlace}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { match: { params: { publisherID: site_id } } } = ownProps;
  const { main: { currentTab }, form: { statForm } } = state;

  return {
    optionsSites: toRenderSelectFormat(state),
    optionsBannerplaces: toRenderSelectBannerplaces(state),
    optionsFormats: toRenderSelectFormats(state),
    optionsAvailableFormats: toRenderFormats(state),
    initialValues: {
      site_id
    },
    ...getDates(state),
    currentTab,
    formats: path(["values", "formats"], statForm)
  };
};

export default connect(mapStateToProps, {
  load,
  changeLocation,
  change
})(Form);
